import { Button, FileInput, Modal, Radio, Textarea } from 'flowbite-react';
import React, { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { Sopform, SopformTypeEnum } from '../../../Models/Sopform';
import { useAppSelector } from '../../../Reducers/store';
import DeliveryApi from '../../../Api/DeliveryApi';
import InspectionApi from '../../../Api/InspectionApi';
import { SopformImageTypeEnum } from '../../../Models/SopformImage';

export default function DriverInspectionCheckModal({
  show,
  setShow,
  inspectionAssetId,
  inspectionType,
  getUserLatestInspection,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  inspectionAssetId: number;
  inspectionType: number;
  getUserLatestInspection: () => Promise<void>;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [today, settoday] = useState<Date>(new Date());
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formSOPData, setformSOPData] = useState<Sopform>({
    id: 0,
    userId: null,
    deliveryId: null,
    damageLeaks: false,
    lightsSignalsBrakes: false,
    safetyEquipmentPpe: false,
    dateCreated: null,
    damageLeaksNotes: null,
    lightsSignalsBrakesNotes: null,
    safetyEquipmentPpenotes: null,

    sopformImages: [],
  });
  const handleResetFormValues = () => {
    const values = {
      id: 0,
      userId: null,
      deliveryId: null,
      damageLeaks: false,
      lightsSignalsBrakes: false,
      safetyEquipmentPpe: false,
      dateCreated: null,
      damageLeaksNotes: null,
      lightsSignalsBrakesNotes: null,
      safetyEquipmentPpenotes: null,

      sopformImages: [],
    };
    setformSOPData(values as Sopform);
    setdamageLeaksFiles(null);
    setlightsSignalsBrakesFiles(null);
    setsafetyEquipmentPpeFiles(null);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (
      name === 'damageLeaks' ||
      name === 'lightsSignalsBrakes' ||
      name === 'safetyEquipmentPpe'
    ) {
      setformSOPData((prevData) => ({ ...prevData, [name]: value === 'true' }));
    } else {
      setformSOPData((prevData) => ({ ...prevData, [name]: value }));
    }
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setformSOPData((prevData) => ({ ...prevData, [name]: value }));
  };

  const [damageLeaksfiles, setdamageLeaksFiles] = useState<FileList | null>();
  const [lightsSignalsBrakesfiles, setlightsSignalsBrakesFiles] =
    useState<FileList | null>();
  const [safetyEquipmentPpefiles, setsafetyEquipmentPpeFiles] =
    useState<FileList | null>();
  function handleImageChange(
    event: React.ChangeEvent<HTMLInputElement>,
    typeId: number
  ) {
    if (typeId === SopformImageTypeEnum.DamageLeaks) {
      if (event.currentTarget.files) {
        setdamageLeaksFiles(event.currentTarget.files);
      } else {
        setdamageLeaksFiles(null);
      }
    }
    if (typeId === SopformImageTypeEnum.LightsSignalsBrakes) {
      if (event.currentTarget.files) {
        setlightsSignalsBrakesFiles(event.currentTarget.files);
      } else {
        setlightsSignalsBrakesFiles(null);
      }
    }
    if (typeId === SopformImageTypeEnum.SafetyEquipmentPpe) {
      if (event.currentTarget.files) {
        setsafetyEquipmentPpeFiles(event.currentTarget.files);
      } else {
        setsafetyEquipmentPpeFiles(null);
      }
    }
  }

  const damageLeaksfilesList = useMemo(() => {
    let list = [''];
    if (damageLeaksfiles) {
      list = Array.from(damageLeaksfiles).map((f) => URL.createObjectURL(f));
    }
    return [...list];
  }, [damageLeaksfiles]);
  const lightsSignalsBrakesfilesList = useMemo(() => {
    let list = [''];
    if (lightsSignalsBrakesfiles) {
      list = Array.from(lightsSignalsBrakesfiles).map((f) =>
        URL.createObjectURL(f)
      );
    }
    return [...list];
  }, [lightsSignalsBrakesfiles]);
  const safetyEquipmentPpefilesList = useMemo(() => {
    let list = [''];
    if (safetyEquipmentPpefiles) {
      list = Array.from(safetyEquipmentPpefiles).map((f) =>
        URL.createObjectURL(f)
      );
    }
    return [...list];
  }, [safetyEquipmentPpefiles]);

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (inspectionAssetId > 0 && inspectionType > 0) {
      setButtonDisabled(true);
      setIsLoading(true);
      let sopformId = 0;
      await DeliveryApi.addUpdateSOPForm(formSOPData)
        .then((res) => {
          if (res.data.success) {
            sopformId = Number(res.data.affectedEntityIdentifier);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
      if (sopformId > 0) {
        await InspectionApi.assignFormToInspectionAsset(
          inspectionAssetId,
          sopformId
        )
          .then((res) => {
            if (res.data.success) {
              toast.success('Success');
            } else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            toast.error('Error: ' + err);
          });
        if (damageLeaksfiles) {
          const fd = new FormData();
          Array.from(damageLeaksfiles).forEach((file) => {
            fd.append('file', file);
          });
          fd.append('typeId', SopformImageTypeEnum.DamageLeaks.toString());
          await InspectionApi.uploadSopFormImages(sopformId, fd)
            .then((res) => {
              if (res.data.success) {
                // imageUpdated = true;
              }
            })
            .catch((err) => {
              toast.error('Image Error: ' + err);
            });
        }
        if (lightsSignalsBrakesfiles) {
          const fd = new FormData();
          Array.from(lightsSignalsBrakesfiles).forEach((file) => {
            fd.append('file', file);
          });
          fd.append(
            'typeId',
            SopformImageTypeEnum.LightsSignalsBrakes.toString()
          );
          await InspectionApi.uploadSopFormImages(sopformId, fd)
            .then((res) => {
              if (res.data.success) {
                // imageUpdated = true;
              }
            })
            .catch((err) => {
              toast.error('Image Error: ' + err);
            });
        }
        if (safetyEquipmentPpefiles) {
          const fd = new FormData();
          Array.from(safetyEquipmentPpefiles).forEach((file) => {
            fd.append('file', file);
          });
          fd.append(
            'typeId',
            SopformImageTypeEnum.SafetyEquipmentPpe.toString()
          );
          await InspectionApi.uploadSopFormImages(sopformId, fd)
            .then((res) => {
              if (res.data.success) {
                // imageUpdated = true;
              }
            })
            .catch((err) => {
              toast.error('Image Error: ' + err);
            });
        }
        setIsLoading(false);
        handleResetFormValues();
        setButtonDisabled(false);
        getUserLatestInspection();
        onCloseModal();
      }
      setButtonDisabled(false);
    }
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header>
          {inspectionType === SopformTypeEnum.PreCheck ? 'Pre' : 'Post'}{' '}
          Inspection
        </Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='container mx-auto p-2'>
                <div className='md:flex no-wrap md:-mx-2 '>
                  <div className='w-full'>
                    <div className='bg-white'>
                      <form id='sopForm' onSubmit={onSubmit}>
                        <div className='text-black'>
                          <div className='flex mb-2 mx-2'>
                            <p className='font-bold content-center'>
                              I, {userModel?.firstName} {userModel?.lastName},
                              on {today.toDateString()} are affirming that I
                              have completed the Pre-Trip Inspection and agree
                              with the following statements:
                            </p>
                          </div>
                          <div className='w-full'>
                            <i></i>
                          </div>
                          <fieldset className='border p-3 gap-3 flex flex-col'>
                            <div>
                              <div className='flex'>
                                <div className='flex ml-2 mr-5 gap-3'>
                                  <div className='flex items-center gap-1'>
                                    <Radio
                                      id='damageLeaks'
                                      name='damageLeaks'
                                      value={'true'}
                                      checked={
                                        formSOPData.damageLeaks ?? undefined
                                      }
                                      onChange={handleChangeInput}
                                    />
                                    <div className='font-bold content-center text-sm'>
                                      Yes
                                    </div>
                                  </div>
                                  <div className='flex items-center gap-1'>
                                    <Radio
                                      id='damageLeaks'
                                      name='damageLeaks'
                                      value={'false'}
                                      checked={
                                        !(formSOPData.damageLeaks ?? true)
                                      }
                                      onChange={handleChangeInput}
                                    />
                                    <div className='font-bold content-center text-sm'>
                                      No
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className='content-center'>
                                    I confirm my delivery vehicle contains no
                                    visible damage or leaks.
                                  </div>
                                </div>
                              </div>
                              {formSOPData.damageLeaks === false && (
                                <div>
                                  <div className='flex'>
                                    <div className='w-1/2'>
                                      <Textarea
                                        id='damageLeaksNotes'
                                        name='damageLeaksNotes'
                                        placeholder='Description...'
                                        onChange={handleChangeTextArea}
                                        value={
                                          formSOPData.damageLeaksNotes ?? ''
                                        }
                                        rows={2}
                                        required={
                                          formSOPData.damageLeaks === false
                                        }
                                        autoComplete='new-password'
                                      />
                                    </div>
                                    <div className='w-1/2'>
                                      <FileInput
                                        id='file-upload'
                                        onChange={(e) =>
                                          handleImageChange(
                                            e,
                                            SopformImageTypeEnum.DamageLeaks
                                          )
                                        }
                                        multiple
                                        disabled={buttonDisabled}
                                      />
                                    </div>
                                  </div>
                                  {damageLeaksfilesList &&
                                    damageLeaksfilesList.length > 0 &&
                                    damageLeaksfilesList[0] !== '' && (
                                      <div className='flex overflow-auto'>
                                        {damageLeaksfilesList.map((x) => (
                                          <img
                                            key={x}
                                            src={x}
                                            className='h-28'
                                          />
                                        ))}
                                      </div>
                                    )}
                                </div>
                              )}
                            </div>
                            <div>
                              <div className='flex'>
                                <div className='flex ml-2 mr-5 gap-3'>
                                  <div className='flex items-center gap-1'>
                                    <Radio
                                      id='lightsSignalsBrakes'
                                      name='lightsSignalsBrakes'
                                      value={'true'}
                                      checked={
                                        formSOPData.lightsSignalsBrakes ??
                                        undefined
                                      }
                                      onChange={handleChangeInput}
                                    />
                                    <div className='font-bold content-center text-sm'>
                                      Yes
                                    </div>
                                  </div>
                                  <div className='flex items-center gap-1'>
                                    <Radio
                                      id='lightsSignalsBrakes'
                                      name='lightsSignalsBrakes'
                                      value={'false'}
                                      checked={
                                        !(
                                          formSOPData.lightsSignalsBrakes ??
                                          true
                                        )
                                      }
                                      onChange={handleChangeInput}
                                    />
                                    <div className='font-bold content-center text-sm'>
                                      No
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className='content-center'>
                                    I confirm that all lights, signals, and
                                    brakes are functioning properly.
                                  </div>
                                </div>
                              </div>
                              {formSOPData.lightsSignalsBrakes === false && (
                                <div>
                                  <div className='flex'>
                                    <div className='w-1/2'>
                                      <Textarea
                                        id='lightsSignalsBrakesNotes'
                                        name='lightsSignalsBrakesNotes'
                                        placeholder='Description...'
                                        onChange={handleChangeTextArea}
                                        value={
                                          formSOPData.lightsSignalsBrakesNotes ??
                                          ''
                                        }
                                        rows={2}
                                        required={
                                          formSOPData.lightsSignalsBrakes ===
                                          false
                                        }
                                        autoComplete='new-password'
                                      />
                                    </div>
                                    <div className='w-1/2'>
                                      <FileInput
                                        id='file-upload'
                                        onChange={(e) =>
                                          handleImageChange(
                                            e,
                                            SopformImageTypeEnum.LightsSignalsBrakes
                                          )
                                        }
                                        multiple
                                        disabled={buttonDisabled}
                                      />
                                    </div>
                                  </div>
                                  {lightsSignalsBrakesfilesList &&
                                    lightsSignalsBrakesfilesList.length > 0 &&
                                    lightsSignalsBrakesfilesList[0] !== '' && (
                                      <div className='flex overflow-auto'>
                                        {lightsSignalsBrakesfilesList.map(
                                          (x) => (
                                            <img
                                              key={x}
                                              src={x}
                                              className='h-28'
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                </div>
                              )}
                            </div>
                            <div>
                              <div className='flex'>
                                <div className='flex ml-2 mr-5 gap-3'>
                                  <div className='flex items-center gap-1'>
                                    <Radio
                                      id='safetyEquipmentPpe'
                                      name='safetyEquipmentPpe'
                                      value={'true'}
                                      checked={
                                        formSOPData.safetyEquipmentPpe ??
                                        undefined
                                      }
                                      onChange={handleChangeInput}
                                    />
                                    <div className='font-bold content-center text-sm'>
                                      Yes
                                    </div>
                                  </div>
                                  <div className='flex items-center gap-1'>
                                    <Radio
                                      id='safetyEquipmentPpe'
                                      name='safetyEquipmentPpe'
                                      value={'false'}
                                      checked={
                                        !(
                                          formSOPData.safetyEquipmentPpe ?? true
                                        )
                                      }
                                      onChange={handleChangeInput}
                                    />
                                    <div className='font-bold content-center text-sm'>
                                      No
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className='content-center'>
                                    I confirm that all necessary safety
                                    equipment is on board, including fire
                                    extinguishers, spill kits, and personal
                                    protective equipment(PPE).
                                  </div>
                                </div>
                              </div>
                              {formSOPData.safetyEquipmentPpe === false && (
                                <div>
                                  <div className='flex'>
                                    <div className='w-1/2'>
                                      <Textarea
                                        id='safetyEquipmentPpenotes'
                                        name='safetyEquipmentPpenotes'
                                        placeholder='Description...'
                                        onChange={handleChangeTextArea}
                                        value={
                                          formSOPData.safetyEquipmentPpenotes ??
                                          ''
                                        }
                                        rows={2}
                                        required={
                                          formSOPData.safetyEquipmentPpe ===
                                          false
                                        }
                                        autoComplete='new-password'
                                      />
                                    </div>
                                    <div className='w-1/2'>
                                      <FileInput
                                        id='file-upload'
                                        onChange={(e) =>
                                          handleImageChange(
                                            e,
                                            SopformImageTypeEnum.SafetyEquipmentPpe
                                          )
                                        }
                                        multiple
                                        disabled={buttonDisabled}
                                      />
                                    </div>
                                  </div>
                                  {safetyEquipmentPpefilesList &&
                                    safetyEquipmentPpefilesList.length > 0 &&
                                    safetyEquipmentPpefilesList[0] !== '' && (
                                      <div className='flex overflow-auto'>
                                        {safetyEquipmentPpefilesList.map(
                                          (x) => (
                                            <img
                                              key={x}
                                              src={x}
                                              className='h-28'
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                </div>
                              )}
                            </div>
                          </fieldset>
                        </div>
                        <div className='flex justify-end pt-2'>
                          <Button
                            disabled={buttonDisabled}
                            type='submit'
                            className='buttonMain'
                            form='sopForm'
                            // onClick={() => onSubmit()}
                          >
                            Submit
                          </Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
